import idGenerator from '../../utils/idGenerator';
import errorMessageMapper from '../storeUtils/errorMessageMapper';
import translation from '../../translation/translation';

// ACTIONS
const types = {
    SET_LOADING: 'SET_LOADING',
    SET_SETTINGS_OPEN: 'SET_SETTINGS_OPEN',
    SET_HELP_OPEN: 'SET_HELP_OPEN',
    SET_ERROR_MESSAGE: 'SET_ERROR_MESSAGE',
    CLEAR_ERROR_MESSAGE: 'CLEAR_ERROR_MESSAGE',
};

const initialState = {
    isLoading: false,
    settingsOpen: false,
    helpOpen: false,
    errorMessages: [],
};

// REDUCER
const reducer = (state = initialState, action) => {
    switch (action.type) {
    case types.SET_LOADING: {
        return Object.assign({}, state, { isLoading: action.value });
    }
    case types.SET_SETTINGS_OPEN: {
        return Object.assign({}, state, { settingsOpen: action.value });
    }
    case types.SET_HELP_OPEN: {
        return Object.assign({}, state, { helpOpen: action.value });
    }
    case types.SET_ERROR_MESSAGE: {
        return Object.assign({}, state, { errorMessages: [action.value, ...state.errorMessages] });
    }
    case types.CLEAR_ERROR_MESSAGE: {
        return Object.assign(
            {},
            state,
            {
                errorMessages: state.errorMessages.filter(
                    message => message.id !== action.value.id,
                ),
            },
        );
    }
    default:
        return state;
    }
};

// ACTION CREATORS
const setLoading = isLoading => ({
    type: types.SET_LOADING,
    value: isLoading,
});
const openSettings = ({
    type: types.SET_SETTINGS_OPEN,
    value: true,
});
const closeSettings = ({
    type: types.SET_SETTINGS_OPEN,
    value: false,
});
const openHelp = ({
    type: types.SET_HELP_OPEN,
    value: true,
});
const closeHelp = ({
    type: types.SET_HELP_OPEN,
    value: false,
});
const setErrorMessageInternal = message => ({
    type: types.SET_ERROR_MESSAGE,
    value: message,
});
const clearErrorMessage = message => ({
    type: types.CLEAR_ERROR_MESSAGE,
    value: message,
});

// THUNK
const setErrorMessage = message => (dispatch, getState) => {
    const error = {
        id: idGenerator(),
        text: errorMessageMapper(message, translation(getState().user.userPreferedLanguage)),
    };
    dispatch(setErrorMessageInternal(error));
};

export {
    types,
    initialState,
    setLoading,
    setErrorMessage,
    clearErrorMessage,
    openSettings,
    closeSettings,
    openHelp,
    closeHelp,
};

export default reducer;
